import CybsAlert from '@cybs-ui/components/lib/alert';
import CybsButton from '@cybs-ui/components/lib/button';
import React from 'react';
import { connect } from 'react-redux';
import { copyStringToClipboard } from '../../../../../libs/common-library';
import { getExampleValue } from '../../../reducers/examples-reducer';
import { getPartnerName } from '../../../../../lhs/reducers/configuration-reducer';
import CodeMirrorEditor from '../js/codemirror-container';
import { disableCopyMessage, enableCopyMessage } from '../js/live-console';




/**
 * Request description in live console tab
 */
 var hasBodyParams = false;

class BodyTabInLiveConsole extends React.Component
{

   render()
   {
    hasBodyParams = (this.props.hasBodyParams == undefined) ? false: this.props.hasBodyParams;

    var copyButtonController;
    copyButtonController = <CybsAlert
    isInline
    isDismissable
    i18n={{
      message: "Copy Successful"
    }}
    status="positive"
    // isVisible={positiveAlertVisible}
    onDismiss={() =>disableCopyMessage("copySuccessful")}
    />
       return(
        <div  id = "bodyTab">
        {
            hasBodyParams &&
            <div>
                <div id = "copySuccessful">{copyButtonController}</div>
                <div id='live-console' style ={{visibility: 'hidden'}}>
                <CodeMirrorEditor/>
                <CybsButton
                  aria-label="Copy button for the code editor"
                  aria-description="On click of this button the code in the code editor gets copied"
                  colorScheme="secondary"
                  className = "requestCopyButton border_color_theme_primary"
                  dataTest="request-copy"
                  i18n={{ ariaLabel: <b>information icon</b>, label: 'Copy' }}
                  resolution="high"
                  iconClass="copy"
                  iconLocation="left"
                  onClick={() => copyContent()}
                />
                {/*<img class = "requestCopyButton" src={copyButton} onClick={() => copyStringToClipboard(getExampleValue(),enableCopyMessage('copySuccessful'))}></img>*/}
                </div>
            </div>
        }
        </div>
       );

    }
}
function mapStateToProps(state){
    return{      
        hasBodyParams : state.lhsReducer.hasBodyParams,
    };
}
function copyContent(){
    let exampleVal = getExampleValue();
    copyStringToClipboard(exampleVal,enableCopyMessage('copySuccessful'));
}

export default connect(mapStateToProps)(BodyTabInLiveConsole);
